import {downloadSettingsValueKey} from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import {defaultHeader, defaultTag86, defaultTag61, defaultTag28, defaultTag20, defaultTag65, defaultStNo, defaultWithoutTr, defaultTrBookingDate}
from "fides-angularjs-components/src/fts-administration/fts-settings";
import {MT942_TYPE} from "../../../components/report/ReportModalController";

const defaultWithSupp = 'WITH_SUPPLEMENTARY_TEXT';
const defaultOriBank = 'ORIGINAL_FROM_BANK';
const defHeader = 'DEFAULT_HEADER';
const defTrBookingDate = 'IF_DIFFERENT';
const defaultSettings = {
    tag61: defaultWithSupp,
    withFullText: true,
    tag28withC: true,
    header: defHeader,
    withDefaultTransactionReference: true,
    mt999Footer: false,
    deliveriesWithoutTransactions: true,
    tag64AlwaysAvailable: false,
    forwardTag65: true,
    statementNo: defaultOriBank,
    trBookingDate: defTrBookingDate
};

/** @ngInject */
export class MT94XUserSettingsMapper {
    constructor(sessionPersistance) {
        this.sessionPersistance = sessionPersistance;
    }

    getMT94XUserSettings(type){
        const userSettingsMT940 = this.sessionPersistance.get(downloadSettingsValueKey);
        if(_.isNil(userSettingsMT940)) {
            return defaultSettings;
        }else if(type === MT942_TYPE && _.isNil(userSettingsMT940.MT942)){
            return defaultSettings;
        }
        const userSettings = type === MT942_TYPE ? userSettingsMT940.MT942 : userSettingsMT940;
        // Set the message type (MT940/MT942) and the file prefix
        const settings = {
            tag61: this.getTag61Parameter(userSettings.tag61),
            withFullText: userSettings.tag86 === defaultTag86,
            tag28withC: userSettings.tag28 === defaultTag28,
            header: this.getHeaderParameter(userSettings.header),
            withDefaultTransactionReference: userSettings.tag20 === defaultTag20,
            mt999Footer: userSettings.mt999Footer === 'SETTINGS_DOWNLOAD_MT999_FOOTER_OPTION_B',
            deliveriesWithoutTransactions: userSettings.withoutTransactions === defaultWithoutTr,
            trBookingDate: this.getTrBookingDateParameter(userSettings.trBookingDate)
        };

        if(type !== MT942_TYPE) {
            settings.forwardTag65 = userSettings.tag65 === defaultTag65;
            settings.tag64AlwaysAvailable = userSettings.tag64 === 'SETTINGS_DOWNLOAD_TAG_64_OPTION_B';
            settings.statementNo = this.getStatementNumberParameter(userSettings.statementNo)
        }
        return settings;
    }

    getTag61Parameter(tag61Option){
        switch(tag61Option){
            case defaultTag61 : return defaultWithSupp;
            case 'SETTINGS_DOWNLOAD_TAG_61_OPTION_B' : return 'WITHOUT_SUPPLEMENTARY_TEXT';
            case 'SETTINGS_DOWNLOAD_TAG_61_OPTION_C' : return 'OVERWRITE_34_CHARS_FROM_TAG_86';
            default: return defaultWithSupp;
        }
    }

    getStatementNumberParameter(statementNo){
        switch(statementNo){
            case defaultStNo : return defaultOriBank;
            case 'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_B' : return 'INCREMENTED_EVERY_STATEMENT';
            case 'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_C' : return 'INCREMENTED_EVERY_STATEMENT_WITH_TR';
            case 'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_D' : return 'INCREMENTED_EVERY_VALUE_DATE_WITH_TR';
            default: return defaultOriBank;
        }
    }

    getHeaderParameter(header){
        switch(header){
            case defaultHeader : return defHeader;
            case 'SETTINGS_DOWNLOAD_HEADER_OPTION_B' : return 'FIDES_HEADER';
            case 'SETTINGS_DOWNLOAD_HEADER_OPTION_C' : return 'NO_HEADER';
            default: return defHeader;
        }
    }

    getTrBookingDateParameter(trBookDate){
        switch(trBookDate){
            case defaultTrBookingDate : return defTrBookingDate;
            case 'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_A' : return 'ALWAYS';
            case 'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_C' : return 'NEVER';
            default: return defTrBookingDate;
        }
    }
}
